<template>
	<span class="pswiper">
        <!-- <b-row class="mb-4">
            <b-col class="text-center">
                <div class="py-2 section-title text-center">{{heading}}</div>
            </b-col>
        </b-row> -->
       
                <div ref="rpswiper" v-swiper:mySwiper="swiperOption" class="px-4">
                    <div class="swiper-wrapper">
						<!--
						 <div class="swiper-slide" v-for="(data,index) in products" :key="index">
							 <template >
							<b-link :href="data.url"><b-img v-bind="socialImg" :src="data.thumbnailUrl" fluid></b-img></b-link>
						  </template>
						</div> -->
						
						<div class="swiper-slide" v-for="(data,index) in instagramfeed" :key="index">
							 <template >
							<b-link href="https://www.instagram.com/alluraaTech/"><b-img v-bind="socialImg" :src="$root.MEDIAPATH+'instagram/'+data.image" fluid></b-img></b-link>
						  </template>
						</div>
					
                    </div>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev" @click="mySwiper.slidePrev()"></div>
                    <div class="swiper-button-next" slot="button-next" @click="mySwiper.slideNext()"></div>
                </div>
          
		</span>
</template>

<script>
export default {
  name: 'InstagramSwiper',
  props: {
    products: { type: Array },
    showQuickViewListener: { type: Function },
    heading: String
  },
  mounted(){
    //this.heading = "Related Products";
	
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
		instagramfeed: [{image:'instagram1.jpg'},{image:'instagram2.jpg'},{image:'instagram3.jpg'},{image:'instagram4.jpg'},{image:'instagram5.jpg'},{image:'instagram6.jpg'},{image:'instagram7.jpg'},{image:'instagram8.jpg'},{image:'instagram9.jpg'},{image:'instagram10.jpg'},{image:'instagram11.jpg'},{image:'instagram12.jpg'}],
		feedindex: 4,
        swiperOption: {
            direction: 'horizontal',
            initialSlide: 0,
            slidesPerGroup: 2,
            loop: false,
            watchSlidesVisibility: true,
            /*preloadImages: false,
            lazy: true,*/
            loopFillGroupWithBlank: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                960: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                1124: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                init: function () {
                    //console.log('swiper initialized');
                },
                slideChange: function() {
                    //console.log('slide changed');
                }
            },
            fadeEffect: {
                crossFade: true
            },
        },
		socialImg:'',
    }
  },
  methods:{
    showQuickView(item){
        this.showQuickViewListener(item);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pswiper{
.swiper-button-next, .swiper-button-prev{
	top: 35%;
}
}

</style>
